<template>
  <div>
    <h1>Выгрузка отчетов</h1>
    <button class="open-modal-btn" @click="openModalMio">Выгрузить отчет для МИО</button>
    <button class="open-modal-btn" @click="openModalMonitoring">Выгрузить отчет для Мониторинга</button>

    <div v-if="showModalMio" class="modal">
      <div class="modal-content">
        <h2>Выберите месяц и год</h2>
        <form @submit.prevent="handleSubmitMio">
          <div class="form-group">
            <label for="kato">Населенный пункт: <span class="required-sign">*</span></label>
            <multiselect
                v-model="kato"
                :options="katoList"
                :searchable="true"
                :closeOnSelect="true"
                track-by="code"
                :custom-label="formattedKatoLabel"
                placeholder="Выберите населенный пункт"
                :multiple="false"
                :clear-on-select="true"
            />
          </div>
          <div class="form-group">
            <label for="startAccountingMonth">Месяц с: <span class="required-sign">*</span></label>
            <input
                type="number"
                id="startAccountingMonth"
                v-model="startAccountingMonth"
                min="1"
                max="12"
                required
            />
          </div>
          <div class="form-group">
            <label for="endAccountingMonth">Месяц до: <span class="required-sign">*</span></label>
            <input
                type="number"
                id="endAccountingMonth"
                v-model="endAccountingMonth"
                min="1"
                max="12"
                required
            />
          </div>

          <div class="form-group">
            <label for="accountingYear">Год: <span class="required-sign">*</span></label>
            <input
                type="number"
                id="accountingYear"
                v-model="accountingYear"
                min="2000"
                required
            />
          </div>

          <button type="submit" class="submit-btn" :disabled="isLoading">
            {{ isLoading ? 'Выгружается...' : 'Выгрузить' }}
          </button>
        </form>
        <button class="close-modal-btn" @click="closeModalMio">Закрыть</button>
      </div>
    </div>
    <div v-if="showModalMonitoring" class="modal">
      <div class="modal-content">
        <h2>Выберите месяц и год</h2>
        <form @submit.prevent="handleSubmitMonitoring">
          <div class="form-group">
            <div class="el-input-group">
              <label for="binList" class="form-label col-md-3">Список бинов:</label>
              <textarea id="binList" cols="15" rows="5" class="form-control" v-model="binList"
                        :disabled="isKatoSelected"
                        placeholder="1234567, 1234567, ...
или
1234567
1234567
..."></textarea>
            </div>
          </div>

          <div class="form-group">
            <div class="el-input-group">
              <label for="lmsIdList" class="form-label col-md-3">Список LMS ID:</label>
              <textarea id="lmsIdList" cols="15" rows="5" class="form-control" v-model="lmsIdList"
                        :disabled="isKatoSelected"
                        placeholder="1-1-1, 1-1-2, ...
или
1-1-1
1-1-2
..."></textarea>
            </div>
          </div>
          <div class="form-group">
            <label for="kato">Населенный пункт: <span class="required-sign">*</span></label>
            <multiselect
                v-model="kato"
                :options="katoList"
                :searchable="true"
                :closeOnSelect="true"
                track-by="code"
                :custom-label="formattedKatoLabel"
                placeholder="Выберите населенный пункт"
                :multiple="false"
                :clear-on-select="true"

            />
          </div>
          <div class="form-group">
            <label for="accountingMonth">Месяц: <span class="required-sign">*</span></label>
            <input
                type="number"
                id="accountingMonth"
                v-model="accountingMonth"
                min="1"
                max="12"
                required
            />
          </div>

          <div class="form-group">
            <label for="accountingYear">Год: <span class="required-sign">*</span></label>
            <input
                type="number"
                id="accountingYear"
                v-model="accountingYear"
                min="2000"
                required
            />
          </div>

          <div v-if="errorMessage" class="error-message">
            {{ errorMessage }}
          </div>
          <button
              type="submit"
              class="submit-btn"
              :disabled="isLoading"
          >
            {{ isLoading ? 'Выгружается...' : 'Выгрузить' }}
          </button>
        </form>
        <button class="close-modal-btn" @click="closeModalMonitoring">Закрыть</button>
      </div>
    </div>



  </div>
  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, ref, watch} from "vue";
import {generate1CReport, generateReportForMIO, generateReportForMonitoring} from "@/services/reportService";
import {
  Generate1CReportAsyncRequest,
  GenerateReportForMIOAsyncRequest,
  GenerateReportForMonitoringAsyncRequest
} from "@/types/report";
import VueLoading from "vue-loading-overlay";
import Multiselect from "vue-multiselect";
import cacheService from "@/services/cacheService";
import {Kato} from "@/types/kindergarten";

export default defineComponent({
  components: {Multiselect, VueLoading},
  setup() {
    const showModalMio = ref(false);
    const showModalMonitoring = ref(false);
    const startAccountingMonth = ref<number>(0);
    const accountingMonth = ref<number>(0);
    const binList = ref("");
    const lmsIdList = ref("");
    const endAccountingMonth = ref<number>(0);
    const accountingYear = ref<number>(0);
    const isLoading = ref(false);
    const params = ref<Generate1CReportAsyncRequest>();
    const katoList = ref<Kato[]>([]);
    const kato = ref<Kato | null>(null);
    const isKatoSelected = computed(() => kato.value !== null && kato.value !== undefined);
    const errorMessage = ref("");

    const fetchCachedDatas = async () => {
      katoList.value = await cacheService.useKatoStore().fetchKato();
    };

    const openModalMio = () => {
      showModalMio.value = true;
    };

    const openModalMonitoring = () => {
      showModalMonitoring.value = true;
    };

    const closeModalMio = () => {
      showModalMio.value = false;
    };
    const closeModalMonitoring = () => {
      showModalMonitoring.value = false;
    };

    const handleSubmitMio = async () => {
      isLoading.value = true;

      try {
        if (startAccountingMonth.value !== undefined && endAccountingMonth.value !== undefined && accountingYear.value !== undefined && kato.value !== null) {
          const params = new GenerateReportForMIOAsyncRequest(startAccountingMonth.value, endAccountingMonth.value, accountingYear.value, kato.value.code);
          isLoading.value = true;
          await generateReportForMIO(params).then(() => {
            closeModalMio();
            isLoading.value = false;
          });
        }
      } catch (error) {
        console.error("Ошибка при выгрузке отчета:", error);
      } finally {
        isLoading.value = false;
      }
    };

    // const handleSubmitMonitoring = async () => {
    //   isLoading.value = true;
    //
    //   try {
    //     // Проверяем обязательные поля
    //     if (!accountingMonth.value || !accountingYear.value) {
    //       throw new Error("Месяц и год обязательны для заполнения");
    //     }
    //
    //     // Проверяем что выбран либо като либо списки
    //     if (!kato.value && !binList.value && !lmsIdList.value) {
    //       throw new Error("Необходимо выбрать либо населенный пункт, либо заполнить один из списков");
    //     }
    //
    //     const params = new GenerateReportForMonitoringAsyncRequest(
    //         accountingMonth.value,
    //         accountingYear.value,
    //         kato.value?.code || null,
    //         binList.value,
    //         lmsIdList.value
    //     );
    //
    //     await generateReportForMonitoring(params);
    //     closeModalMonitoring(); // было closeModalMio
    //   } catch (error) {
    //     console.error("Ошибка при выгрузке отчета:", error);
    //   } finally {
    //     isLoading.value = false;
    //   }
    // };


    //TODO TEST
    const handleSubmitMonitoring = async () => {
      errorMessage.value = ""; // очищаем ошибку при каждом новом сабмите

      // Сначала проверяем обязательные поля: месяц и год
      if (!accountingMonth.value || !accountingYear.value) {
        errorMessage.value = "Заполните месяц и год";
        return;
      }

      // Проверяем валидность месяца
      if (accountingMonth.value < 1 || accountingMonth.value > 12) {
        errorMessage.value = "Месяц должен быть от 1 до 12";
        return;
      }

      // Проверяем что выбран хотя бы один способ фильтрации (КАТО или списки)
      if (!kato.value && binList.value.trim() === '' && lmsIdList.value.trim() === '') {
        errorMessage.value = "Выберите населенный пункт или заполните список БИН/LMS ID";
        return;
      }

      // Проверяем что не выбраны одновременно КАТО и списки
      if (kato.value && (binList.value.trim() !== '' || lmsIdList.value.trim() !== '')) {
        errorMessage.value = "Нельзя одновременно выбирать населенный пункт и заполнять списки";
        return;
      }

      // Проверяем что не заполнены оба списка одновременно
      if (binList.value.trim() !== '' && lmsIdList.value.trim() !== '') {
        errorMessage.value = "Заполните только один список: либо БИН, либо LMS ID";
        return;
      }

      isLoading.value = true;

      try {
        const params = new GenerateReportForMonitoringAsyncRequest(
            accountingMonth.value,
            accountingYear.value,
            kato.value?.code || null,
            binList.value,
            lmsIdList.value
        );
        await generateReportForMonitoring(params);
        closeModalMonitoring();
      } catch (error: unknown) {
        if (error instanceof Error) {
          errorMessage.value = error.message || "Произошла ошибка при формировании отчета";
        } else {
          errorMessage.value = "Произошла ошибка при формировании отчета";
        }
      } finally {
        isLoading.value = false;
      }
    };

    const isFormValid = computed(() => {
      // Проверяем обязательные поля
      if (!accountingMonth.value || !accountingYear.value) {
        return false;
      }
      // Проверяем что выбран либо като либо списки
      if (!kato.value && !binList.value && !lmsIdList.value) {
        return false;
      }
      return true;
    });

    watch(kato, (newVal) => {
      if (newVal) {
        binList.value = '';
        lmsIdList.value = '';
      }
    });


    const translateStatus = (status: string): string => {
      switch (status) {
        case "GENERATING":
          return "Файл в процессе";
        case "GENERATED":
          return "Файл создан";
        case "ERROR":
          return "Неизвестная ошибка";
        default:
          return "Неизвестно";
      }
    };

    onMounted(() => {
      fetchCachedDatas();
    });

    const formattedKatoLabel = (item: any) => {
      return `${item.code} | ${item.nameRu}`;
    };

    return {
      showModalMio,
      showModalMonitoring,
      startAccountingMonth,
      accountingMonth,
      endAccountingMonth,
      accountingYear,
      binList,
      lmsIdList,
      isLoading,
      openModalMio,
      openModalMonitoring,
      closeModalMio,
      closeModalMonitoring,
      handleSubmitMio,
      handleSubmitMonitoring,
      translateStatus,
      params,
      formattedKatoLabel,
      kato,
      katoList,
      isKatoSelected,
      isFormValid,
      errorMessage
    };
  }
});
</script>

<style scoped>
h1 {
  text-align: center;
  margin-top: 20px;
}

.error-message {
  color: #dc3545;
  font-size: 14px;
  margin-bottom: 10px;
}

.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h2 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #45a049;
}

.submit-btn:disabled {
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed !important;
  border: none;
}

.close-modal-btn {
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.close-modal-btn:hover {
  background-color: #e31b0c;
}

.reports-table th,
.reports-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.reports-table th {
  background-color: #4caf50;
  color: white;
}

.required-sign {
  color: red;
}

</style>